import React, {useState, useEffect, useCallback} from 'react';
import styles from './CustomMoreSection.module.css';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconTouch } from '../../assets/icons/icon_touch.svg';
import { ReactComponent as IconUsage } from '../../assets/icons/icon_usage.svg';
import { ReactComponent as IconContact } from '../../assets/icons/icon_contact.svg';
import { ReactComponent as IconAddAccount } from '../../assets/icons/icon_add_account.svg';
import { ReactComponent as IconDownloadApp } from '../../assets/icons/icon_download_app.svg';
import { ReactComponent as IconDownloadEditor } from '../../assets/icons/icon_download_editor.svg';
import { getForWhomMenuContent } from '../../services/contentService';
import CustomLoader from '../customLoader/CustomLoader';
import CustomImage from '../customImage/CustomImage';
import { useNavigate, useParams } from 'react-router-dom';

type CustomMoreSectionProps = {
    isForWhomPage?: boolean;
    isStore?: boolean;
}

const CustomMoreSection = (props: CustomMoreSectionProps) => {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const { sectionId } = useParams();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [forWhomSections, setForWhomSections] = useState<any>();

    const handleGetForWhomMenuContent = useCallback(async () => {
        try {
            setIsLoading(true);

            const content = await getForWhomMenuContent();
            const forWhomContent = content.sections
                .map((item: any, index: number) => {
                    return {
                        index: index,
                        iconUrl: item.Section_presentation_card.icon?.url,
                        title: item.Section_presentation_card.title
                    }
                })
                .filter((el: any) => Number(sectionId) !== el.index);
            
            setForWhomSections(forWhomContent);
            setIsLoading(false);
        } catch(e) {
            console.error(e);
            throw e;
        }
    }, [sectionId]);

    const getSection =() => {
        if (props.isForWhomPage) {
            return (
                <>
                    <h2>{t('custom_more_section.title')}</h2>
                    <div className={`${styles.content} ${styles.for_whom_content}`}>
                        <div className={styles.contact_us_container}>
                            <div>
                                <IconContact />
                                <p>{t('custom_more_section.contact_us')}</p>
                            </div>
                        </div>
                        
                        { !isLoading && forWhomSections.map((item: any, index: number) => {
                            return (
                                <div key={index} onClick={() => navigate(`/for_whom/${item.index}`)} role='button' tabIndex={0}>
                                    <div className={styles.icon}>
                                        <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${item.iconUrl}`} alt="" />
                                    </div>
                                    <p>{item.title}</p>
                                </div>
                            );
                        })}

                        { isLoading &&
                            <div className={styles.loader}>
                                <CustomLoader loaderType='skeleton' isLoading={isLoading} />
                            </div>
                        }
                    </div>
                </>
            );
        }

        if (props.isStore) {
            return (
                <>
                    <h2>{t('custom_more_section.store_title')}</h2>
                    <div className={`${styles.content} ${styles.store_section}`}>
                        <div role='button' tabIndex={0} onClick={() => navigate('/signin')}>
                            <div>
                                <IconAddAccount />
                            </div>
                            <p>{t('custom_more_section.create_account')}</p>
                        </div>

                        <div>
                            <div>
                                <IconDownloadApp />
                            </div>
                            <div>
                                <p>{t('custom_more_section.download_app')}</p>
                                <span className={styles.android_apple}>({t('custom_more_section.android_ios')})</span>
                            </div>
                        </div>

                        <div>
                            <div>
                                <IconDownloadEditor />
                            </div>
                            <p>{t('custom_more_section.download_editor')}</p>
                        </div>
                    </div>
                </>
            );
        }

        return (
            <>
                <h2>{t('custom_more_section.title')}</h2>
                <div className={styles.content}>
                    <div>
                        <IconUsage />
                        <p>{t('custom_more_section.discover')}</p>
                    </div>

                    <div>
                        <IconTouch />
                        <p>{t('custom_more_section.access')}</p>
                    </div>
                </div>
            </>
        );
    }

    useEffect(() => {
        if (props.isForWhomPage)
            handleGetForWhomMenuContent();
    }, [handleGetForWhomMenuContent, props.isForWhomPage]);

    return (
        <div className={styles.container}>
            {getSection()}
        </div>
    );
}

export default CustomMoreSection;